import * as React from "react";
const SvgRequired = (props) => /* @__PURE__ */ React.createElement("svg", { width: 7, height: 7, viewBox: "0 0 7 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.88358 0.852898H3.72358L3.63958 3.1929L5.77558 2.3769L6.03958 3.1689L3.83158 3.8289L5.31958 5.5929L4.67158 6.1089L3.30358 4.2129L1.93558 6.1089L1.28758 5.5929L2.77558 3.8289L0.567578 3.1689L0.831578 2.3769L2.97958 3.1929L2.88358 0.852898Z", fill: "#F53E31", style: {
  fill: "#F53E31",
  fill: "color(display-p3 0.9600 0.2432 0.1920)",
  fillOpacity: 1
} }));
export default SvgRequired;
